<p-button
  icon="pi pi-calendar"
  severity="primary"
  [outlined]="true"
  styleClass="cx-datepicker-trigger"
  [label]="displayRangeLabel"
  (onClick)="togglePopover($event)">
</p-button>

<p-popover
  #popover
  [dismissable]="true"
  [focusOnShow]="false"
  [appendTo]="'body'"
  (onShow)="onPopoverShow()"
  (onHide)="onPopoverHide()"
  styleClass="cx-range-popover">
  <p-datepicker
    styleClass="cx-range-inline-picker"
    [(ngModel)]="draftRangeValue"
    [inline]="true"
    [selectionMode]="'range'"
    [numberOfMonths]="2"
    [defaultDate]="startDate"
    [minDate]="minDate"
    [maxDate]="effectiveMaxDate"
    (onSelect)="onDateSelect($event)"
    (onMonthChange)="onCalendarPanelChanged()"
    (onYearChange)="onCalendarPanelChanged()"
    [firstDayOfWeek]="1">
  </p-datepicker>

  <div class="cx-range-actions">
    <div class="cx-range-presets">
      <p-button
        [label]="quickRangeLabels.today"
        size="small"
        severity="secondary"
        [outlined]="activeQuickRangeDays !== 0"
        (onClick)="onQuickRangeClick(0)">
      </p-button>
      <p-button
        [label]="quickRangeLabels.last7"
        size="small"
        severity="secondary"
        [outlined]="activeQuickRangeDays !== 7"
        (onClick)="onQuickRangeClick(7)">
      </p-button>
      <p-button
        [label]="quickRangeLabels.last30"
        size="small"
        severity="secondary"
        [outlined]="activeQuickRangeDays !== 30"
        (onClick)="onQuickRangeClick(30)">
      </p-button>
      @if (showLast90Days) {
        <p-button
          [label]="quickRangeLabels.last90"
          size="small"
          severity="secondary"
          [outlined]="activeQuickRangeDays !== 90"
          (onClick)="onQuickRangeClick(90)">
        </p-button>
      }
    </div>

    <div class="d-flex align-items-center gap-2 justify-content-end">
      @if (isRangeExceedingMax) {
        <small class="text-danger">
          {{ '::DatePicker:MaxRangeDays' | abpLocalization : maxRangeDays }}
        </small>
      }
      <p-button
        [label]="labels.apply | abpLocalization"
        size="small"
        [disabled]="!canApply"
        (onClick)="onApplyClick()">
      </p-button>
    </div>
  </div>
</p-popover>
